(function () {
  'use strict';

  var qs = function (sel, el) { return (el || document).querySelector(sel); };
  var qsa = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var routes = window.routes || { root_url: '/', cart_url: '/cart', cart_add_url: '/cart/add', cart_change_url: '/cart/change' };
  var MAX_QTY = 10; // most units of one item allowed in an order

  function formatMoney(cents) {
    var value = cents / 100;
    var hasPaise = Math.round(cents) % 100 !== 0;
    return '₹' + value.toLocaleString('en-IN', {
      minimumFractionDigits: hasPaise ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  var ICON_MINUS = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
  var ICON_PLUS = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  /* ---------- Drawers ---------- */

  var lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var panel = qs('[data-drawer-panel]', drawer);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!qs('.drawer.is-open')) document.documentElement.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function initDrawers() {
    var menu = qs('[data-menu-drawer]');
    qsa('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(menu);
        btn.setAttribute('aria-expanded', 'true');
      });
    });
    qsa('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDrawer(menu);
        qsa('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      });
    });
    if (menu) {
      qsa('a', menu).forEach(function (link) {
        link.addEventListener('click', function () { closeDrawer(menu); });
      });
    }

    var cartDrawer = qs('[data-cart-drawer]');
    var onCartPage = document.body.classList.contains('template-cart');
    qsa('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        if (onCartPage || !cartDrawer) return;
        event.preventDefault();
        refreshCart().then(function () { openDrawer(cartDrawer); });
      });
    });
    qsa('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDrawer(cartDrawer); });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') qsa('.drawer.is-open').forEach(closeDrawer);
    });
  }

  /* ---------- Cart ---------- */

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });

    var itemsEl = qs('[data-cart-items]');
    var foot = qs('[data-cart-foot]');
    var titleCount = qs('[data-cart-title-count]');
    var banner = qs('[data-cart-banner]');
    if (!itemsEl) return cart;

    if (titleCount) titleCount.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (banner) banner.hidden = !cart.item_count;

    if (!cart.item_count) {
      itemsEl.innerHTML =
        '<div class="drawer__empty"><p>Your cart is empty.</p>' +
        '<a class="btn btn--brown" href="' + routes.root_url + '">Continue shopping</a></div>';
      if (foot) foot.hidden = true;
      return cart;
    }

    if (foot) foot.hidden = false;
    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var image = item.image
        ? '<img class="cart-item__img" src="' + escapeHtml(sizedImage(item.image, 200)) + '" alt="" width="80" height="80" loading="lazy">'
        : '<span class="cart-item__img"></span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-item__meta">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      return '' +
        '<div class="cart-item">' +
          '<a href="' + escapeHtml(item.url) + '">' + image + '</a>' +
          '<div>' +
            '<a class="cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<div class="cart-item__row">' +
              '<div class="qty qty--sm">' +
                '<button type="button" class="qty__btn" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
                '<span class="qty__input" style="display:flex;align-items:center;justify-content:center">' + item.quantity + '</span>' +
                '<button type="button" class="qty__btn" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity"' + (item.quantity >= MAX_QTY ? ' disabled' : '') + '>' + ICON_PLUS + '</button>' +
              '</div>' +
              '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-item__remove" data-line="' + line + '" data-qty="0">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');

    var subtotal = qs('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    return cart;
  }

  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () { return null; });
  }

  function changeLine(line, quantity) {
    var itemsEl = qs('[data-cart-items]');
    if (itemsEl) itemsEl.style.opacity = '.5';
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.min(MAX_QTY, Math.max(0, quantity)) })
    })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .finally(function () { if (itemsEl) itemsEl.style.opacity = ''; });
  }

  function initCartDrawer() {
    var itemsEl = qs('[data-cart-items]');
    if (!itemsEl) return;
    itemsEl.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-line]');
      if (!btn) return;
      changeLine(parseInt(btn.getAttribute('data-line'), 10), parseInt(btn.getAttribute('data-qty'), 10));
    });
  }

  /* ---------- Lazy videos ---------- */
  // Story videos download only when scrolled into view, and pause when off screen.

  function initLazyVideos() {
    var boxes = qsa('[data-lazy-video]');
    if (!boxes.length) return;
    function play(video) {
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) {
      boxes.forEach(function (box) { var v = qs('video', box); if (v) play(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = qs('video', entry.target);
        if (!video) return;
        if (entry.isIntersecting) play(video);
        else video.pause();
      });
    }, { rootMargin: '200px 0px' });
    boxes.forEach(function (box) { io.observe(box); });
  }

  /* ---------- Live chat (Shopify Inbox) ---------- */
  // The chat lives in an open shadow root, so theme CSS can't reach it; adopt our own sheet there.
  // Solid white panel, branded blue header, blue launcher, no "Sign in" button.

  var CHAT_CSS = [
    '.panel__sign-in, .new-chat-popover__button--primary { display: none !important; }',
    '.panel { background-color: #fff !important; background-image: none !important; backdrop-filter: none !important; border: 1px solid #e4e7ec; box-shadow: 0 24px 64px rgba(16,24,40,.22), 0 4px 12px rgba(16,24,40,.08) !important; }',
    '.desktop-layout .panel { --private-panel-cap-height: 560px !important; }',
    '.panel__header { background: linear-gradient(135deg, #1a8cff 0%, #0063d1 100%); box-shadow: 0 2px 10px rgba(0,72,160,.25); }',
    '.panel__header-column--left::before { content: "Grabzo Support"; display: block; padding-left: 4px; color: #fff; font-size: 16px; font-weight: 800; white-space: nowrap; }',
    '.panel__header-column--left::after { content: "Ask us anything \\00B7  Hindi / English"; position: absolute; left: 4px; top: calc(50% + 11px); color: #cfe5ff; font-size: 12px; font-weight: 600; white-space: nowrap; }',
    // New-chat (pencil) button sits on the right beside expand/close, not on top of the title.
    '.panel__header-column--left { flex: 1 1 auto; display: flex; align-items: center; }',
    '.panel__chat-actions { margin-left: auto; margin-right: 8px; }',
    // Sign-in / contact views show a back arrow in the title's place.
    ':host(:is([view="login"], [view="legacy-contact"])) .panel__header-column--left::before, :host(:is([view="login"], [view="legacy-contact"])) .panel__header-column--left::after { display: none; }',
    // Launcher: brand gradient with a white ring, larger icon, "online" dot and a soft pulse.
    '.activator { --activator-bg: #0070e0 !important; --activator-fg: #fff !important; position: relative !important; overflow: visible !important; width: 58px !important; height: 58px !important; min-width: 58px !important; border: 3px solid #fff !important; background: linear-gradient(135deg, #2b95ff 0%, #0057c2 100%) !important; color: #fff !important; font-weight: 700; box-shadow: 0 12px 28px rgba(0,87,194,.38), 0 3px 8px rgba(16,24,40,.16) !important; transition: transform .2s ease !important; }',
    '.activator:hover { transform: scale(1.06); }',
    '.activator__icon { width: 26px !important; height: 26px !important; }',
    '.activator__icon svg { width: 100% !important; height: 100% !important; }',
    '.activator::before { content: ""; position: absolute; inset: -3px; border: 2px solid rgba(43,149,255,.6); border-radius: 50%; pointer-events: none; animation: gz-ring 2.6s ease-out infinite; }',
    '@keyframes gz-ring { 0% { transform: scale(1); opacity: .9; } 75%, 100% { transform: scale(1.5); opacity: 0; } }',
    '.activator::after { content: ""; position: absolute; right: 0; bottom: 1px; width: 14px; height: 14px; box-sizing: border-box; border: 2.5px solid #fff; border-radius: 50%; background: #22c55e; }',
    '@media (prefers-reduced-motion: reduce) { .activator::before { animation: none; opacity: 0; } }'
  ].join('\n');

  // A one-time hint beside the chat launcher, once per visit.
  var CHAT_TIP_TEXT = 'Questions? Chat with us';

  function chatLauncher() {
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if (!root) return null;
    var runtime = root.querySelector('shopify-agent-runtime');
    return (runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('.activator')) || root.querySelector('.activator');
  }

  function initChatTip() {
    try { if (sessionStorage.getItem('gz-chat-tip')) return; } catch (e) {}
    var tries = 0;
    var timer = setInterval(function () {
      var button = chatLauncher();
      var rect = button && button.getBoundingClientRect();
      if (!rect || !rect.width) {
        if (++tries > 8) clearInterval(timer);
        return;
      }
      clearInterval(timer);
      if (button.getAttribute('aria-expanded') === 'true') return;
      try { sessionStorage.setItem('gz-chat-tip', '1'); } catch (e) {}

      var tip = document.createElement('button');
      tip.type = 'button';
      tip.className = 'chat-tip';
      tip.innerHTML = '<span class="chat-tip__dot" aria-hidden="true"></span>' + CHAT_TIP_TEXT;
      document.body.appendChild(tip);

      // Anchor to the bottom like the launcher, and re-align while the phone's address bar
      // shows/hides during scrolling, so the hint stays beside the button.
      function place() {
        var r = button.getBoundingClientRect();
        tip.style.right = (document.documentElement.clientWidth - r.left + 12) + 'px';
        tip.style.bottom = (window.innerHeight - r.bottom + (r.height - tip.offsetHeight) / 2) + 'px';
      }
      place();
      window.addEventListener('scroll', place, { passive: true });
      window.addEventListener('resize', place);

      var gone = false;
      function hide() {
        if (gone) return;
        gone = true;
        window.removeEventListener('scroll', place);
        window.removeEventListener('resize', place);
        tip.classList.remove('is-in');
        setTimeout(function () { tip.remove(); }, 400);
      }
      tip.addEventListener('click', function () { button.click(); hide(); });
      button.addEventListener('click', hide);
      window.requestAnimationFrame(function () { tip.classList.add('is-in'); });
      setTimeout(hide, 7000);
    }, 1000);
  }

  function initChatStyle() {
    var sheet;
    try { sheet = new CSSStyleSheet(); sheet.replaceSync(CHAT_CSS); } catch (e) { return; }
    function adopt(root) {
      if (root && 'adoptedStyleSheets' in root && root.adoptedStyleSheets.indexOf(sheet) === -1) {
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      }
    }
    // The first launcher is drawn in <shopify-chat>'s own shadow root; the full chat
    // (<shopify-agent-runtime>) is added inside it later and can reset its sheets when it
    // re-renders, so keep re-checking (a cheap lookup) for the life of the page.
    function apply() {
      var host = document.querySelector('shopify-chat');
      var root = host && host.shadowRoot;
      if (!root) return false;
      adopt(root);
      if (!root.__gzWatched) {
        // Re-adopt as soon as the app draws or redraws the launcher.
        root.__gzWatched = true;
        new MutationObserver(apply).observe(root, { childList: true, subtree: true });
      }
      var runtime = root.querySelector('shopify-agent-runtime');
      if (runtime) adopt(runtime.shadowRoot);
      return true;
    }
    // Look every frame until the launcher first appears, so it never shows the app's
    // own colour before ours; after that the slow check is enough.
    var started = Date.now();
    (function early() {
      if (apply() || Date.now() - started > 15000) return;
      requestAnimationFrame(early);
    })();
    setInterval(apply, 700);
  }

  /* ---------- Reviews ---------- */
  // Published Judge.me reviews in the theme's own design.

  var REVIEWS_API = 'https://api.judge.me/reviews/reviews_for_widget';
  var REVIEWS_PER_REQUEST = 20;
  var REVIEWS_MAX_PAGES = 15;
  var STAR_PATH = 'M12 2.6l2.85 5.95 6.55.83-4.8 4.55 1.22 6.5L12 17.3l-5.82 3.13 1.22-6.5-4.8-4.55 6.55-.83z';
  var ICON_VERIFIED = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="currentColor"/><path d="M7.5 12.4l3 3 6-6.2" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var reviewRequests = {};

  function starsHtml(rating, size) {
    var html = '<span class="stars' + (size ? ' stars--' + size : '') + '" role="img" aria-label="' + rating.toFixed(1) + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) {
      var fill = Math.max(0, Math.min(1, rating - (i - 1)));
      html += '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="stars__bg" d="' + STAR_PATH + '"/>' +
        '<path class="stars__fg" d="' + STAR_PATH + '" style="clip-path:inset(0 ' + Math.round(100 - fill * 100) + '% 0 0)"/></svg>';
    }
    return html + '</span>';
  }

  // One request chain per product, shared by the rating line and the section.
  function publishedReviews(productId) {
    if (reviewRequests[productId]) return reviewRequests[productId];
    var shop = (window.Shopify && window.Shopify.shop) || window.location.hostname;
    var found = [];
    function page(n) {
      var url = REVIEWS_API + '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&per_page=' + REVIEWS_PER_REQUEST + '&page=' + n + '&product_id=' + productId;
      return fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('Reviews request failed');
          return res.json();
        })
        .then(function (data) {
          var list = data.reviews || [];
          list.forEach(function (review) { found.push(review); });
          return list.length === REVIEWS_PER_REQUEST && n < REVIEWS_MAX_PAGES ? page(n + 1) : uniqueReviews(found);
        });
    }
    reviewRequests[productId] = page(1);
    return reviewRequests[productId];
  }

  function averageRating(reviews) {
    return reviews.reduce(function (sum, r) { return sum + (r.rating || 0); }, 0) / reviews.length;
  }

  function reviewText(html) {
    return new DOMParser().parseFromString(html || '', 'text/html').body.textContent.trim();
  }

  // Hide repeated imports with the same author, text, title, rating and review date.
  function uniqueReviews(reviews) {
    var result = [];
    var seen = Object.create(null);
    function normalText(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
    reviews.forEach(function (review) {
      var name = normalText(review.reviewer_name);
      var body = normalText(reviewText(review.body_html));
      var date = new Date(review.created_at || '');
      if (!name || !body || isNaN(date.getTime())) {
        result.push(review);
        return;
      }
      var key = JSON.stringify([name, normalText(review.title), Number(review.rating), body, date.toISOString().slice(0, 10)]);
      if (typeof seen[key] === 'number') {
        var index = seen[key];
        var current = result[index];
        if ((review.verified_buyer === true && current.verified_buyer !== true) ||
            (review.verified_buyer === current.verified_buyer && !(current.pictures_urls || []).length && (review.pictures_urls || []).length)) {
          result[index] = review;
        }
      } else {
        seen[key] = result.length;
        result.push(review);
      }
    });
    return result;
  }

  function pictureUrl(pic) {
    if (!pic) return '';
    if (typeof pic === 'string') return pic;
    var urls = pic.urls || pic;
    return urls.compact || urls.small || urls.huge || urls.original || '';
  }

  function reviewCard(r) {
    var name = r.reviewer_name || 'Customer';
    // Remove known import-number suffixes from display titles only.
    var title = String(r.title || '').trim().replace(/^(Gets it done|Perfect quality|Awesome purchase|A bit heavy|Not bad|Amazing addition to my toolbox|Great product|Amazing value|Great nail gun - highly recommended|Amazing product|Works as expected|Good nail gun|Very useful tool)\s+\d{1,3}$/i, '$1');
    var pics = (r.pictures_urls || []).map(pictureUrl).filter(Boolean).slice(0, 3);
    var meta = [pics.length ? 'Photo review' : '', r.location].filter(Boolean).join(' · ');
    return '<article class="review">' +
      '<div class="review__head">' +
        '<span class="review__avatar" aria-hidden="true">' + escapeHtml(name.charAt(0).toUpperCase()) + '</span>' +
        '<div><p class="review__name">' + escapeHtml(name) + '</p>' +
        (r.verified_buyer === true ? '<p class="review__badge">' + ICON_VERIFIED + 'Verified buyer</p>' : '') + '</div>' +
      '</div>' +
      '<div class="review__rating">' + starsHtml(r.rating || 0) + (meta ? '<span class="review__meta">' + escapeHtml(meta) + '</span>' : '') + '</div>' +
      (title ? '<p class="review__title">' + escapeHtml(title) + '</p>' : '') +
      '<p class="review__body">' + escapeHtml(reviewText(r.body_html)) + '</p>' +
      (pics.length ? '<div class="review__pics">' + pics.map(function (src) {
        return '<img src="' + escapeHtml(src) + '" alt="Photo from ' + escapeHtml(name) + '" loading="lazy" width="72" height="72">';
      }).join('') + '</div>' : '') +
    '</article>';
  }

  function summaryHtml(reviews) {
    var avg = averageRating(reviews);
    var counts = [0, 0, 0, 0, 0];
    reviews.forEach(function (r) { var s = Math.round(r.rating || 0); if (s >= 1 && s <= 5) counts[s - 1]++; });
    var bars = '';
    for (var s = 5; s >= 1; s--) {
      var pct = Math.round(counts[s - 1] * 100 / reviews.length);
      bars += '<div class="reviews__bar"><span>' + s + ' ★</span><span class="reviews__track"><span class="reviews__fill" style="width:' + pct + '%"></span></span><span>' + counts[s - 1] + '</span></div>';
    }
    return '<div class="reviews__score"><p class="reviews__avg">' + avg.toFixed(1) + '</p>' + starsHtml(avg, 'lg') +
      '<p class="reviews__total">' + reviews.length + ' review' + (reviews.length === 1 ? '' : 's') + '</p></div>' +
      '<div class="reviews__bars">' + bars + '</div>';
  }

  function initReviewSection(section) {
    var list = qs('[data-reviews-list]', section);
    var summary = qs('[data-reviews-summary]', section);
    var empty = qs('[data-reviews-empty]', section);
    var more = qs('[data-reviews-more]', section);
    var pageSize = parseInt(section.getAttribute('data-page-size'), 10) || 6;

    publishedReviews(section.getAttribute('data-product-id'))
      .then(function (reviews) {
        if (!reviews.length) {
          if (section.hasAttribute('data-hide-empty')) section.hidden = true;
          else empty.hidden = false;
          return;
        }
        reviews.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });
        summary.innerHTML = summaryHtml(reviews);
        summary.hidden = false;
        var shown = 0;
        function showMore() {
          list.insertAdjacentHTML('beforeend', reviews.slice(shown, shown + pageSize).map(reviewCard).join(''));
          shown = Math.min(reviews.length, shown + pageSize);
          more.hidden = shown >= reviews.length;
        }
        more.addEventListener('click', showMore);
        showMore();
      })
      .catch(function () { section.hidden = true; });
  }

  function initRatingLine(link) {
    publishedReviews(link.getAttribute('data-product-id'))
      .then(function (reviews) {
        if (!reviews.length) return;
        var avg = averageRating(reviews);
        link.innerHTML = starsHtml(avg) + '<span class="rating-line__avg">' + avg.toFixed(1) + '</span>' +
          '<span class="rating-line__count">' + reviews.length + ' review' + (reviews.length === 1 ? '' : 's') + '</span>';
        if (!document.getElementById('reviews')) link.removeAttribute('href');
        link.hidden = false;
      })
      .catch(function () {});
  }

  function initReviews() {
    qsa('[data-reviews]').forEach(initReviewSection);
    qsa('[data-rating-line]').forEach(initRatingLine);
  }

  /* ---------- Home hero slider ---------- */
  // Swipeable product banner: dots follow the scroll, autoplay pauses while the visitor touches it.

  var HERO_DELAY = 4500;

  function initHeroSlider(root) {
    var track = qs('[data-hs-track]', root);
    var slides = qsa('[data-hs-slide]', track);
    var dotsWrap = qs('[data-hs-dots]', root);
    if (!track || slides.length < 2) return;

    function step() { return slides[1].offsetLeft - slides[0].offsetLeft; }
    function current() { return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step()))); }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function goTo(i) { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }

    var dots = slides.map(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hs__dot';
      dot.setAttribute('aria-label', 'Show product ' + (i + 1));
      dot.addEventListener('click', function () { pause(); goTo(i); });
      dotsWrap.appendChild(dot);
      return dot;
    });

    function paintDots() {
      var i = atEnd() ? slides.length - 1 : current();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; paintDots(); });
    }, { passive: true });
    paintDots();

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var resumeAt = 0;
    function pause() { resumeAt = Date.now() + HERO_DELAY * 2; }
    ['pointerdown', 'touchstart', 'wheel', 'mouseenter'].forEach(function (type) {
      track.addEventListener(type, pause, { passive: true });
    });

    setInterval(function () {
      if (document.hidden || Date.now() < resumeAt) return;
      var rect = track.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      goTo(atEnd() ? 0 : current() + 1);
    }, HERO_DELAY);
  }

  /* ---------- Gallery ---------- */

  function initGallery(root) {
    var viewport = qs('[data-gallery-viewport]', root);
    var slides = qsa('[data-gallery-slide]', root);
    if (!viewport || !slides.length) return null;
    var thumbs = qsa('[data-gallery-thumb]', root);
    var dots = qsa('[data-gallery-dot]', root);
    var thumbsWrap = qs('[data-gallery-thumbs]', root);
    var prev = qs('[data-gallery-prev]', root);
    var next = qs('[data-gallery-next]', root);
    var index = -1;

    function setActive(i) {
      if (i === index) return;
      index = i;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      slides.forEach(function (slide, n) {
        if (n === i) return;
        var video = qs('video', slide);
        if (video && !video.paused) video.pause();
      });
      var thumb = thumbs[i];
      if (thumb && thumbsWrap) {
        var target = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.clientWidth) / 2;
        thumbsWrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    }

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      viewport.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });

    thumbs.forEach(function (thumb, n) {
      thumb.addEventListener('click', function () { goTo(n); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
    });

    setActive(0);

    return {
      goToMedia: function (mediaId) {
        slides.forEach(function (slide, n) {
          if (slide.getAttribute('data-media-id') === String(mediaId)) goTo(n);
        });
      }
    };
  }

  /* ---------- Delivery timeline (business days, Sundays skipped) ---------- */

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++;
    }
    return d;
  }

  function shortDate(d) {
    return d.getDate() + ' ' + d.toLocaleDateString('en-IN', { month: 'short' });
  }

  function dateRange(a, b) {
    if (a.getMonth() === b.getMonth()) {
      return a.getDate() + ' – ' + shortDate(b);
    }
    return shortDate(a) + ' – ' + shortDate(b);
  }

  function initTimeline(el) {
    var today = new Date();
    var n = function (attr, fallback) {
      var v = parseInt(el.getAttribute(attr), 10);
      return isNaN(v) ? fallback : v;
    };
    var ship = qs('[data-date-ship]', el);
    var deliver = qs('[data-date-deliver]', el);
    if (ship) ship.textContent = dateRange(addBusinessDays(today, n('data-ship-min', 1)), addBusinessDays(today, n('data-ship-max', 2)));
    if (deliver) deliver.textContent = dateRange(addBusinessDays(today, n('data-deliver-min', 4)), addBusinessDays(today, n('data-deliver-max', 7)));
  }

  /* ---------- Product ---------- */

  function initProduct(box) {
    var form = qs('form[data-product-form]', box);
    if (!form) return;
    var gallery = initGallery(box);
    var idInput = qs('[data-variant-id]', form);
    var qtyInput = qs('[data-qty-input]', box);
    var errorEl = qs('[data-form-error]', box);
    var addBtn = qs('[data-add-to-cart]', box);
    var buyBtns = qsa('[data-buy-now]', box);
    var productJson = qs('[data-product-json]', box);
    var product = null;
    try { product = productJson ? JSON.parse(productJson.textContent) : null; } catch (e) { product = null; }

    qsa('[data-timeline]', box).forEach(initTimeline);

    function currentQty() {
      var q = parseInt(qtyInput ? qtyInput.value : '1', 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }

    // Highest quantity allowed with the chosen combo (no line above MAX_QTY units).
    function maxQty() {
      var offer = typeof selectedOffer === 'function' ? selectedOffer() : null;
      return offer && offer.qty > 0 ? Math.max(1, Math.floor(MAX_QTY / offer.qty)) : MAX_QTY;
    }
    function setQty(value) {
      if (!qtyInput) return;
      var max = maxQty();
      var q = Math.min(max, Math.max(1, value));
      qtyInput.value = q;
      qtyInput.max = max;
      var plus = qs('[data-qty-plus]', box);
      var minus = qs('[data-qty-minus]', box);
      if (plus) plus.disabled = q >= max;
      if (minus) minus.disabled = q <= 1;
    }
    qsa('[data-qty-minus], [data-qty-plus]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(currentQty() + (btn.hasAttribute('data-qty-plus') ? 1 : -1));
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(currentQty()); });

    function updatePrice(variant) {
      qsa('[data-price-now]', box).forEach(function (el) { el.textContent = formatMoney(variant.price); });
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      qsa('[data-price-was]', box).forEach(function (el) {
        el.hidden = !onSale;
        var value = qs('[data-price-was-value]', el);
        if (onSale && value) value.textContent = formatMoney(variant.compare_at_price);
      });
      qsa('[data-price-save]', box).forEach(function (el) {
        el.hidden = !onSale;
        if (onSale) el.textContent = 'Off ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      });
      qsa('[data-save-amount]', box).forEach(function (el) {
        el.hidden = !onSale;
        if (onSale) el.textContent = 'You save ' + formatMoney(variant.compare_at_price - variant.price);
      });
      qsa('[data-coupon]', box).forEach(function (el) {
        var off = parseInt(el.getAttribute('data-coupon-amount'), 10) || 0;
        var value = qs('[data-coupon-price]', el);
        if (value) value.textContent = formatMoney(Math.max(0, variant.price - off));
      });
    }

    function setAvailability(available) {
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold out';
      }
      buyBtns.forEach(function (b) { b.disabled = !available; });
    }

    // Combo offers (main product + add-on packs)
    var offersEl = qs('[data-offers]', box);
    function selectedOffer() {
      if (!offersEl) return null;
      var input = qs('[data-offer-input]:checked', offersEl);
      if (!input) return null;
      return {
        qty: parseInt(input.value, 10) || 0,
        price: parseInt(input.getAttribute('data-price'), 10),
        compare: parseInt(input.getAttribute('data-compare'), 10),
        label: input.getAttribute('data-label')
      };
    }
    function applyOffer() {
      var offer = selectedOffer();
      if (!offer) return;
      updatePrice({ price: offer.price, compare_at_price: offer.compare });
      var selected = qs('[data-offer-selected]', offersEl);
      if (selected) selected.textContent = offer.label + ' @ ' + formatMoney(offer.price);
      setQty(currentQty());
    }
    if (offersEl) {
      qsa('[data-offer-input]', offersEl).forEach(function (input) {
        input.addEventListener('change', applyOffer);
      });
    }
    setQty(currentQty());
    function cartItems() {
      var qty = currentQty();
      var items = [{ id: parseInt(idInput.value, 10), quantity: qty }];
      var offer = selectedOffer();
      if (offer && offer.qty > 0) {
        items.push({ id: parseInt(offersEl.getAttribute('data-addon-id'), 10), quantity: offer.qty * qty });
      }
      return items;
    }

    qsa('[data-option-input]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        if (!product) return;
        var selected = qsa('[data-option-index]', form).map(function (fieldset) {
          var checked = qs('input:checked', fieldset);
          return checked ? checked.value : null;
        });
        qsa('[data-option-selected]', form).forEach(function (el, i) { el.textContent = selected[i] || ''; });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (!variant) { setAvailability(false); return; }
        idInput.value = variant.id;
        updatePrice(variant);
        setAvailability(variant.available);
        showError('');
        if (variant.featured_media && gallery) gallery.goToMedia(variant.featured_media.id);
        if (box.hasAttribute('data-update-url') && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    function goToCheckout(items) {
      window.location.href = routes.root_url.replace(/\/$/, '') + '/cart/' + items.map(function (item) { return item.id + ':' + item.quantity; }).join(',');
    }

    // Order now: straight to Shopify checkout with the gun and the chosen nail pack.
    buyBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        btn.classList.add('is-loading');
        goToCheckout(cartItems());
        setTimeout(function () { btn.classList.remove('is-loading'); }, 6000);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      showError('');
      if (addBtn) addBtn.classList.add('is-loading');
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: cartItems() })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            throw new Error(result.data.description || result.data.message || 'Could not add this item. Please try again.');
          }
          return refreshCart().then(function () { openDrawer(qs('[data-cart-drawer]')); });
        })
        .catch(function (err) { showError(err.message); })
        .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
    });

    var sticky = qs('[data-sticky-buy]', box);
    var actions = qs('[data-buy-actions]', box);
    if (sticky && actions && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-buy');
      var stickyBtn = qs('button', sticky);
      var setSticky = function (visible) {
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
      };
      setSticky(false);
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setSticky(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(actions);
    }
  }

  // "Copy" on the coupon box: copies the code and confirms for a moment.
  function initCouponCopy() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-coupon-copy]');
      if (!btn) return;
      var code = btn.getAttribute('data-coupon-copy');
      var done = function () {
        btn.textContent = 'Copied';
        btn.classList.add('is-copied');
        setTimeout(function () { btn.textContent = 'Copy'; btn.classList.remove('is-copied'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        try { document.execCommand('copy'); } catch (e) {}
        field.remove();
        done();
      }
    });
  }

  function init() {
    initDrawers();
    initCouponCopy();
    initCartDrawer();
    initLazyVideos();
    initChatStyle();
    setTimeout(initChatTip, 2500);
    qsa('[data-hs]').forEach(initHeroSlider);
    qsa('[data-product]').forEach(initProduct);
    (window.requestIdleCallback || setTimeout)(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
